export const defaultDomains = ['dev.localclarity.com', 'app.localclarity.com', 'localhost:3000', 'app.localclarity.com.br', 'reputationmanager.io','canada.localclarity.com']

export const chatEnabledDomains = ['dev.localclarity.com', 'app.localclarity.com', 'localhost:3000', 'reputationmanager.io']